import React from 'react';

export const PatientSummaryHeader = ({
  patient,
  layoutFormat,
  onChangeLayout,
  onBackToList,
}) => {
  if (!patient) return null;

  const hasCritical = patient.tests?.some((t) => t.hasCriticalResult);

  return (
    <div className="path-summary-header-card">
      {/* Top Banner Row */}
      <div className="path-summary-top-row">
        {/* Left: Back Action + Patient Identity */}
        <div className="path-summary-title-group">
          <button
            type="button"
            className="path-btn path-btn-back"
            onClick={onBackToList}
            title="Return to Patient Worklist"
          >
            <span className="back-arrow">←</span> Worklist
          </button>
          
          <div className="path-summary-patient-meta">
            <div className="path-name-row">
              <h2 className="path-summary-patient-name">{patient.patientName}</h2>
              <span className="path-gender-badge">{patient.ageGender || 'Age: N/A'}</span>
              <span className="path-id-pill">
                <span className="pill-lbl">UHID:</span>
                <span className="pill-val">{patient.patientId || '—'}</span>
              </span>
              <span className="path-id-pill">
                <span className="pill-lbl">LAB NO:</span>
                <span className="pill-val">{patient.ledgerTransactionNo}</span>
              </span>
              <span className="path-id-pill path-id-panel" title="Registration Panel">
                <span className="pill-lbl">PANEL:</span>
                <span className="pill-val">{patient.panelName || 'Direct Walk-In'}</span>
              </span>
              {hasCritical && (
                <span className="path-status-badge status-critical">⚠️ CRITICAL</span>
              )}
            </div>
          </div>
        </div>

        {/* Right: Layout Switcher */}
        <div className="path-layout-config-box">
          <span className="path-layout-label">VIEW:</span>
          <div className="path-layout-toggle-group">
            <button
              type="button"
              className={`path-layout-btn ${layoutFormat === 'tab-wise' ? 'active' : ''}`}
              onClick={() => onChangeLayout('tab-wise')}
              title="Tab-Wise Result Entry"
            >
              📑 Tab-Wise
            </button>
            <button
              type="button"
              className={`path-layout-btn ${layoutFormat === 'stacked' ? 'active' : ''}`}
              onClick={() => onChangeLayout('stacked')}
              title="Stacked One-Page Result Entry"
            >
              📜 Stacked
            </button>
            <button
              type="button"
              className={`path-layout-btn ${layoutFormat === 'compact' ? 'active' : ''}`}
              onClick={() => onChangeLayout('compact')}
              title="Compact Grid"
            >
              🗂️ Grid
            </button>
          </div>
        </div>
      </div>

      {/* Structured Details Strip (Clean Medical Info Cards) */}
      <div className="path-summary-details-grid">
        <div className="path-summary-item">
          <div className="item-icon">🏷️</div>
          <div className="item-content">
            <span className="lbl">Barcode / Accession</span>
            <span className="val barcode-val">{patient.barcodeNo || '—'}</span>
          </div>
        </div>

        <div className="path-summary-item">
          <div className="item-icon">🩸</div>
          <div className="item-content">
            <span className="lbl">Sample Type</span>
            <span className="val">{patient.sampleTypeName || 'Blood / Serum'}</span>
          </div>
        </div>

        <div className="path-summary-item">
          <div className="item-icon">🕒</div>
          <div className="item-content">
            <span className="lbl">Sample Received</span>
            <span className="val" title={patient.sampleReceiveDate}>
              {patient.sampleReceiveDate
                ? new Date(patient.sampleReceiveDate).toLocaleString('en-IN', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                  })
                : '—'}
            </span>
          </div>
        </div>

        <div className="path-summary-item">
          <div className="item-icon">👨‍⚕️</div>
          <div className="item-content">
            <span className="lbl">Referring Doctor</span>
            <span className="val" title={patient.doctorName}>{patient.doctorName || 'Self / Walk-in'}</span>
          </div>
        </div>

        <div className="path-summary-item">
          <div className="item-icon">🔬</div>
          <div className="item-content">
            <span className="lbl">Department</span>
            <span className="val">{patient.departmentName || 'Biochemistry'}</span>
          </div>
        </div>

        <div className="path-summary-item">
          <div className="item-icon">📋</div>
          <div className="item-content">
            <span className="lbl">Assigned Tests</span>
            <span className="val highlight-val">{patient.tests?.length || 1} Investigation(s)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientSummaryHeader;
